// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ── y축 최대값 드래그 (나.5) ─────────────────────────────────────── */
/* 축 눈금 위에 겹쳐 두는 투명한 띠. 여기를 잡고 위아래로 끌면 최대값이 바뀐다.
   보이지 않으면 아무도 못 찾으므로 hover 에서 손잡이 자국을 낸다. */
.panelchart-ydrag {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 24px;            /* 범례 영역은 비켜 둔다 */
  cursor: ns-resize;
  z-index: 2;
  border-right: 2px solid transparent;
  transition: border-color 150ms ease, background 150ms ease;
}

.panelchart-ydrag:hover {
  background: rgba(59, 130, 246, 0.08);
  border-right-color: #3b82f6;
}

/* 오른쪽 보조 축 — 오른쪽 여백(16px) 안쪽의 축 칸 위에. 위치(right)는 그래프가 준다 */
.panelchart-ydrag-right {
  left: auto;
  border-right: none;
  border-left: 2px solid transparent;
}
.panelchart-ydrag-right:hover { border-left-color: #3b82f6; }

.panelchart-yreset {
  position: absolute;
  right: 6px;
  top: 2px;
  z-index: 3;
  padding: 1px 7px;
  border-radius: 9px;
  border: 1px solid #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 10.5px;
  line-height: 15px;
  cursor: pointer;
  transition: background 150ms ease;
}

.panelchart-yreset:hover { background: #dbeafe; }

[data-theme="dark"] .panelchart-yreset {
  background: #1e3a8a;
  border-color: #1d4ed8;
  color: #dbeafe;
}

[data-theme="dark"] .panelchart-yreset:hover { background: #1e40af; }

@media (prefers-reduced-motion: reduce) {
  .panelchart-ydrag,
  .panelchart-yreset { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/PanelChart.css"],"names":[],"mappings":";AACA,gEAAgE;AAChE;4CAC4C;AAC5C;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY,aAAa,iBAAiB;EAC1C,iBAAiB;EACjB,UAAU;EACV,mCAAmC;EACnC,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,UAAU;EACV,kBAAkB;EAClB,kCAAkC;AACpC;AACA,gCAAgC,0BAA0B,EAAE;;AAE5D;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+CAA+C,mBAAmB,EAAE;;AAEpE;EACE;uBACqB,gBAAgB,EAAE;AACzC","sourcesContent":["\r\n/* ── y축 최대값 드래그 (나.5) ─────────────────────────────────────── */\r\n/* 축 눈금 위에 겹쳐 두는 투명한 띠. 여기를 잡고 위아래로 끌면 최대값이 바뀐다.\r\n   보이지 않으면 아무도 못 찾으므로 hover 에서 손잡이 자국을 낸다. */\r\n.panelchart-ydrag {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 24px;            /* 범례 영역은 비켜 둔다 */\r\n  cursor: ns-resize;\r\n  z-index: 2;\r\n  border-right: 2px solid transparent;\r\n  transition: border-color 150ms ease, background 150ms ease;\r\n}\r\n\r\n.panelchart-ydrag:hover {\r\n  background: rgba(59, 130, 246, 0.08);\r\n  border-right-color: #3b82f6;\r\n}\r\n\r\n/* 오른쪽 보조 축 — 오른쪽 여백(16px) 안쪽의 축 칸 위에. 위치(right)는 그래프가 준다 */\r\n.panelchart-ydrag-right {\r\n  left: auto;\r\n  border-right: none;\r\n  border-left: 2px solid transparent;\r\n}\r\n.panelchart-ydrag-right:hover { border-left-color: #3b82f6; }\r\n\r\n.panelchart-yreset {\r\n  position: absolute;\r\n  right: 6px;\r\n  top: 2px;\r\n  z-index: 3;\r\n  padding: 1px 7px;\r\n  border-radius: 9px;\r\n  border: 1px solid #93c5fd;\r\n  background: #eff6ff;\r\n  color: #1d4ed8;\r\n  font-size: 10.5px;\r\n  line-height: 15px;\r\n  cursor: pointer;\r\n  transition: background 150ms ease;\r\n}\r\n\r\n.panelchart-yreset:hover { background: #dbeafe; }\r\n\r\n[data-theme=\"dark\"] .panelchart-yreset {\r\n  background: #1e3a8a;\r\n  border-color: #1d4ed8;\r\n  color: #dbeafe;\r\n}\r\n\r\n[data-theme=\"dark\"] .panelchart-yreset:hover { background: #1e40af; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .panelchart-ydrag,\r\n  .panelchart-yreset { transition: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
